import type { FaireProductEntity } from "../../entity_types/product";

export const p_az4n38krcc: FaireProductEntity = {
  token: "p_az4n38krcc",
  type: "product",
  name: "Shell Tassel Fish Hook Earrings",
  brandName: "paperln",
  imageUrl:
    "https://cdn.faire.com/fastly/72a9e3bf36b88d43af8168bf12a057b3e9cb499bf8711755cc18f016bc3e5b2c.png",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d6e19d197f24f731ef8d8bdc90394eb7ce8df0b71410afe13b50e0e9b8b19163.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
